// fetch(`/.netlify/functions/fetch-movie?query=${mySearch}`).then((response) =>
//   console.log(response.json())
// );
// fetch(`/.netlify/functions/fetch-movie`).then((response) =>
//   console.log(response.json())
// );
// https://api.themoviedb.org/3/discover/movie?api_key=###&with_genres=28
//by id
//https://api.themoviedb.org/3/movie/343611?api_key=###
const $0f1d4402dffacf5b$export$437edcd314f9b537 = [];
const $0f1d4402dffacf5b$export$7bc6a23777133712 = [];
const $0f1d4402dffacf5b$var$watchListArray = localStorage.getItem("watchList") ? JSON.parse(localStorage.getItem("watchList")) : [];
const $0f1d4402dffacf5b$export$6405226d42414f72 = async function() {
    try {
        const response = await fetch(`/.netlify/functions/fetch-movie`);
        const movies = await response.json();
        const data = movies.results;
        data.forEach((item)=>{
            $0f1d4402dffacf5b$export$437edcd314f9b537.push(item);
        });
        return data;
    } catch (error) {
        console.log(error);
    }
};
const $0f1d4402dffacf5b$export$b0c4d3ac9887d994 = async function(query) {
    try {
        const response = await fetch(`/.netlify/functions/fetch-movie?query=${query}`);
        const movies = await response.json();
        const data = movies.results;
        return data;
    } catch (error) {
        console.log(error);
    }
};
const $0f1d4402dffacf5b$export$dff0df0fb1888b81 = async function(query) {
    try {
        const response = await fetch(`/.netlify/functions/fetch-movie?with_genres=${query}`);
        const movies = await response.json();
        const data = movies.results;
        return data;
    } catch (error) {
        console.log(error);
    }
};
const $0f1d4402dffacf5b$export$f3928fa528b0a11c = async function(query, id) {
    try {
        const response = await fetch(`/.netlify/functions/fetch-movie?query=${query}`);
        const movies = await response.json();
        const data = movies.results;
        const watchList = localStorage.getItem("watchList") ? JSON.parse(localStorage.getItem("watchList")) : [];
        data.forEach((movie)=>{
            if (watchList.length === 0 || movie.id === Number(id)) {
                const duplicateCheck = watchList.some((listItem)=>listItem.id === movie.id);
                if (duplicateCheck === false) {
                    watchList.push(movie);
                    localStorage.setItem("watchList", JSON.stringify(watchList));
                } else {
                    console.log("Movie is already in your watchlist");
                    throw new Error("Movie is already in your watchlist");
                }
            }
        });
    } catch (error) {
        throw error;
    }
};
const $0f1d4402dffacf5b$export$63174eb60e426b63 = function(id) {
    const watchList = localStorage.getItem("watchList") ? JSON.parse(localStorage.getItem("watchList")) : [];
    const filteredArray = watchList.filter((movie)=>{
        if (movie.id !== Number(id)) return movie;
    });
    localStorage.setItem("watchList", JSON.stringify(filteredArray));
};


// --------- DROPDOWN MENU ---------
document.addEventListener("click", (e)=>{
    const isDropdownButton = e.target.matches("[data-dropdown-button]");
    const caret = document.querySelector(".fa-caret-down");
    if (!isDropdownButton && e.target.closest("[data-dropdown]") != null) return;
    let currentDropdown;
    if (isDropdownButton) {
        currentDropdown = e.target.closest("[data-dropdown]");
        currentDropdown.classList.toggle("active");
        caret.classList.toggle("fa-caret-down__rotate");
    }
    document.querySelectorAll("[data-dropdown].active").forEach((dropdown)=>{
        if (dropdown === currentDropdown) return;
        dropdown.classList.remove("active");
        caret.classList.remove("fa-caret-down__rotate");
    });
});
// --------- GENRE ID FROM API ---------
const $0d253f80dc492c18$var$genreID = {
    action: 28,
    adventure: 12,
    animation: 16,
    comedy: 35,
    crime: 80,
    documentary: 99,
    drama: 18,
    family: 10751,
    fantasy: 14,
    history: 36,
    horror: 27,
    music: 10402,
    mystery: 9648,
    romance: 10749,
    science_fiction: 878,
    tv_movie: 10770,
    thriller: 53,
    war: 10752,
    western: 37
};
// --------- HELPER FUNCTIONS ---------
const $0d253f80dc492c18$var$firstLetterCapitalize = function(word) {
    const firstLetter = word.charAt(0).toUpperCase();
    const remaining = word.slice(1);
    return `${firstLetter}${remaining}`;
};
const $0d253f80dc492c18$var$convertKey2Title = function(id) {
    for (const [key, value] of Object.entries($0d253f80dc492c18$var$genreID))if (id === value) {
        if (key.includes("_")) {
            const split = key.split("_");
            return split.map((word)=>$0d253f80dc492c18$var$firstLetterCapitalize(word)).join(" ");
        } else return $0d253f80dc492c18$var$firstLetterCapitalize(key);
    }
};
const $0d253f80dc492c18$var$generateGenre = function(data) {
    return data.genre_ids.map((id)=>{
        for (const [key, value] of Object.entries($0d253f80dc492c18$var$genreID))if (id === value) {
            if (key.includes("_")) {
                const split = key.split("_");
                return split.map((word)=>$0d253f80dc492c18$var$firstLetterCapitalize(word)).join(" ");
            } else return $0d253f80dc492c18$var$firstLetterCapitalize(key);
        }
    }).join(", ");
};
const $0d253f80dc492c18$export$d0ef1bf9bfa6564 = function(message) {
    const modal = document.querySelector(".modal");
    const modalMessage = document.querySelector(".modal__message");
    modalMessage.textContent = message;
    modal.classList.add("active");
    setTimeout(()=>{
        modal.classList.remove("active");
    }, 3000);
};
const $0d253f80dc492c18$export$b0c42ac82fb8127 = function(handler) {
    document.addEventListener("click", function(e) {
        if (e.target.matches(".featured__list") || e.target.matches(".swiper-list-button") || e.target.matches(".movie-grid__list-button")) handler($0d253f80dc492c18$var$clickedTitle, $0d253f80dc492c18$var$clickedID);
    });
};
const $0d253f80dc492c18$export$5e5c8210e5686582 = function(data) {
    const random = Math.floor(Math.random() * 20);
    const randomSelectedMovie = data[random];
    const imgPath = "https://image.tmdb.org/t/p/original";
    const genre = $0d253f80dc492c18$var$generateGenre(randomSelectedMovie);
    document.body.style.backgroundImage = `linear-gradient(to bottom right, rgba(13, 16, 24, 0.8), rgba(0, 0, 0, 0.9)), url(${imgPath}${randomSelectedMovie.backdrop_path})`;
    // CREATE FEATURED MOVIE ELEMENTS ----------------
    const container = document.createElement("div");
    container.classList.add("container");
    const featured = document.createElement("section");
    featured.classList.add("featured");
    const featuredTitle = document.createElement("h1");
    featuredTitle.classList.add("featured__title");
    featuredTitle.textContent = randomSelectedMovie.title;
    const featuredInfo = document.createElement("div");
    featuredInfo.classList.add("featured__info");
    const featuredDate = document.createElement("h2");
    featuredDate.classList.add("featured__date");
    featuredDate.textContent = randomSelectedMovie.release_date.slice(0, 4);
    const featuredGenre = document.createElement("h2");
    featuredGenre.classList.add("featured__genre");
    featuredGenre.textContent = genre;
    const featuredOverview = document.createElement("p");
    featuredOverview.classList.add("featured__overview");
    featuredOverview.dataset.title = randomSelectedMovie.title;
    featuredOverview.dataset.movie_id = randomSelectedMovie.id;
    featuredOverview.textContent = randomSelectedMovie.overview;
    const featuredWatch = document.createElement("button");
    featuredWatch.classList.add("featured__watch");
    featuredWatch.textContent = "Start";
    const featuredList = document.createElement("button");
    featuredList.classList.add("featured__list");
    featuredList.textContent = "Add to List";
    featuredList.addEventListener("click", function() {
        $0d253f80dc492c18$var$clickedTitle = this.previousSibling.previousSibling.dataset.title;
        $0d253f80dc492c18$var$clickedID = this.previousSibling.previousSibling.dataset.movie_id;
        $0d253f80dc492c18$export$d0ef1bf9bfa6564();
    });
    // CREATE SWIPER ELEMENTS ----------------
    const swiper = document.createElement("div");
    swiper.classList.add("swiper");
    const swiperWrapper = document.createElement("div");
    swiperWrapper.classList.add("swiper-wrapper");
    const swiperPrev = document.createElement("div");
    swiperPrev.classList.add("swiper-button-prev");
    const swiperNext = document.createElement("div");
    swiperNext.classList.add("swiper-button-next");
    // ATTACH ELEMENTS ----------------
    $0d253f80dc492c18$var$main.innerHTML = "";
    featuredInfo.appendChild(featuredDate);
    featuredInfo.appendChild(featuredGenre);
    featured.appendChild(featuredTitle);
    featured.appendChild(featuredInfo);
    featured.appendChild(featuredOverview);
    featured.appendChild(featuredWatch);
    featured.appendChild(featuredList);
    container.appendChild(featured);
    swiper.appendChild(swiperWrapper);
    swiper.appendChild(swiperPrev);
    swiper.appendChild(swiperNext);
    container.appendChild(swiper);
    $0d253f80dc492c18$var$main.appendChild(container);
    $0d253f80dc492c18$var$populateSlider(data, swiperWrapper);
};
const $0d253f80dc492c18$var$navLogo = document.getElementById("nav-logo");
const $0d253f80dc492c18$var$navHome = document.getElementById("nav-home");
const $0d253f80dc492c18$export$f3d839c0582bbe9c = function(handler) {
    $0d253f80dc492c18$var$navLogo.addEventListener("click", handler);
    $0d253f80dc492c18$var$navHome.addEventListener("click", handler);
};
// --------- HOME PAGE SLIDER ---------
const $0d253f80dc492c18$var$populateSlider = function(data, container) {
    const imgPath = "https://image.tmdb.org/t/p/original";
    data.forEach((movie)=>{
        const newDIV = document.createElement("div");
        newDIV.classList.add("swiper-slide");
        const newImg = document.createElement("img");
        newImg.classList.add("swiper-img");
        newImg.dataset.title = movie.original_title;
        newImg.dataset.movie_id = movie.id;
        newImg.src = `${imgPath}${movie.poster_path}`;
        const newWatchButton = document.createElement("button");
        newWatchButton.classList.add("swiper-watch-button");
        newWatchButton.textContent = "Watch";
        newWatchButton.addEventListener("click", function() {
            $0d253f80dc492c18$var$clickedTitle = this.previousSibling.dataset.title;
            $0d253f80dc492c18$var$clickedID = this.previousSibling.dataset.movie_id;
        });
        const newListButton = document.createElement("button");
        newListButton.classList.add("swiper-list-button");
        newListButton.textContent = "Add to List";
        newListButton.addEventListener("click", function() {
            $0d253f80dc492c18$var$clickedTitle = this.previousSibling.previousSibling.dataset.title;
            $0d253f80dc492c18$var$clickedID = this.previousSibling.previousSibling.dataset.movie_id;
        // modalConfirmation();
        });
        newDIV.appendChild(newImg);
        newDIV.appendChild(newWatchButton);
        newDIV.appendChild(newListButton);
        container.appendChild(newDIV);
    });
    // SWIPER ------------------------------
    const swiper = new Swiper(".swiper", {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: "true"
        },
        mousewheel: {
            invert: true
        },
        keyboard: {
            enabled: true
        },
        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 10,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 460px
            460: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is >= 720px
            720: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            // when window width is >= 1000px
            1000: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            // when window width is >= 1400px
            1400: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            // when window width is >= 1700px
            1700: {
                slidesPerView: 5,
                spaceBetween: 40
            }
        }
    });
};
// --------- MOBILE MENU HAMBURGER ---------
const $0d253f80dc492c18$var$main = document.querySelector(".main");
const $0d253f80dc492c18$var$hamburgerMenu = document.querySelector(".mobile-menu__hamburger");
const $0d253f80dc492c18$var$mobileMenu = document.querySelector(".mobile-menu__off-screen");
$0d253f80dc492c18$var$hamburgerMenu.addEventListener("click", function() {
    $0d253f80dc492c18$var$main.classList.toggle("active");
    $0d253f80dc492c18$var$hamburgerMenu.classList.toggle("active");
    $0d253f80dc492c18$var$mobileMenu.classList.toggle("active");
});
// --------- MOBILE MENU ---------
const $0d253f80dc492c18$var$mobileHome = document.getElementById("mobile-home");
const $0d253f80dc492c18$var$mobileWatchList = document.getElementById("mobile-watchlist");
const $0d253f80dc492c18$var$mobileGenreLink = document.querySelectorAll(".mobile-menu__genre-link");
const $0d253f80dc492c18$export$a11e9b05256bf37c = function(handler) {
    $0d253f80dc492c18$var$mobileHome.addEventListener("click", function() {
        handler();
        $0d253f80dc492c18$var$main.classList.toggle("active");
        $0d253f80dc492c18$var$hamburgerMenu.classList.toggle("active");
        $0d253f80dc492c18$var$mobileMenu.classList.toggle("active");
    });
};
$0d253f80dc492c18$var$mobileWatchList.addEventListener("click", function() {
    $0d253f80dc492c18$export$990ba021348cea03();
    $0d253f80dc492c18$var$main.classList.toggle("active");
    $0d253f80dc492c18$var$hamburgerMenu.classList.toggle("active");
    $0d253f80dc492c18$var$mobileMenu.classList.toggle("active");
});
const $0d253f80dc492c18$export$96250e6ba255f1e1 = function(handler) {
    $0d253f80dc492c18$var$mobileGenreLink.forEach((link)=>{
        link.addEventListener("click", function(e) {
            let query = e.target.dataset.genre;
            if (query.includes(" ")) query = query.split(" ").join("_");
            handler($0d253f80dc492c18$var$genreID[query]);
            $0d253f80dc492c18$var$main.classList.toggle("active");
            $0d253f80dc492c18$var$hamburgerMenu.classList.toggle("active");
            $0d253f80dc492c18$var$mobileMenu.classList.toggle("active");
        });
    });
};
const $0d253f80dc492c18$export$427e1bf20300bdf0 = async function(result, query) {
    const main = document.querySelector(".main");
    const imgPath = "https://image.tmdb.org/t/p/original";
    const container = document.createElement("div");
    container.classList.add("container");
    container.classList.add("grid");
    const genreTitle = document.createElement("h2");
    genreTitle.classList.add("movie-grid__title");
    genreTitle.textContent = $0d253f80dc492c18$var$convertKey2Title(query);
    container.appendChild(genreTitle);
    result.forEach((movie)=>{
        const movieGridItem = document.createElement("div");
        movieGridItem.classList.add("movie-grid__item");
        const movieGridIMG = document.createElement("img");
        movieGridIMG.dataset.title = movie.original_title;
        movieGridIMG.dataset.movie_id = movie.id;
        movieGridIMG.classList.add("movie-grid__img");
        movieGridIMG.src = `${imgPath}${movie.poster_path}`;
        const newWatchButton = document.createElement("button");
        newWatchButton.classList.add("movie-grid__watch-button");
        newWatchButton.textContent = "Watch";
        newWatchButton.addEventListener("click", function() {
            $0d253f80dc492c18$var$clickedTitle = this.previousSibling.dataset.title;
            $0d253f80dc492c18$var$clickedID = this.previousSibling.dataset.movie_id;
        });
        const newListButton = document.createElement("button");
        newListButton.classList.add("movie-grid__list-button");
        newListButton.textContent = "Add to List";
        newListButton.addEventListener("click", function() {
            $0d253f80dc492c18$var$clickedTitle = this.previousSibling.previousSibling.dataset.title;
            $0d253f80dc492c18$var$clickedID = this.previousSibling.previousSibling.dataset.movie_id;
        // modalConfirmation();
        });
        movieGridItem.appendChild(movieGridIMG);
        movieGridItem.appendChild(newWatchButton);
        movieGridItem.appendChild(newListButton);
        container.appendChild(movieGridItem);
    });
    main.innerHTML = "";
    main.appendChild(container);
};
const $0d253f80dc492c18$export$fd3ff2941ee1f095 = function(handler) {
    const dropdownLink = document.querySelectorAll(".dropdown__link");
    dropdownLink.forEach((link)=>{
        link.addEventListener("click", function(e) {
            let query = e.target.dataset.genre;
            if (query.includes(" ")) query = query.split(" ").join("_");
            handler($0d253f80dc492c18$var$genreID[query]);
            const dropDown = e.target.closest("[data-dropdown]");
            const caret = document.querySelector(".fa-caret-down");
            dropDown.classList.remove("active");
            caret.classList.remove("fa-caret-down__rotate");
        });
    });
};
// --------- WATCH DOM RENDER ---------
let $0d253f80dc492c18$var$clickedTitle;
let $0d253f80dc492c18$var$clickedID;
const $0d253f80dc492c18$export$361292eb141e7484 = function(handler) {
    document.addEventListener("click", function(e) {
        if (e.target.matches(".swiper-watch-button") || e.target.matches(".movie-grid__watch-button")) handler($0d253f80dc492c18$var$clickedTitle);
    });
};
const $0d253f80dc492c18$export$be99db7b1960a5b8 = function(result, query) {
    const data = result.filter((movie)=>{
        if (movie.id === Number($0d253f80dc492c18$var$clickedID)) return movie;
    })[0];
    const genre = $0d253f80dc492c18$var$generateGenre(data);
    const imgPath = "https://image.tmdb.org/t/p/original";
    document.body.style.backgroundImage = `linear-gradient(to bottom right, rgba(13, 16, 24, 0.8), rgba(0, 0, 0, 0.9)), url(${imgPath}${data.backdrop_path})`;
    const featuredTitle = document.querySelector(".featured__title");
    const featuredInfo = document.querySelector(".featured__info");
    const featuredDate = document.querySelector(".featured__date");
    const featuredGenre = document.querySelector(".featured__genre");
    const featuredOverview = document.querySelector(".featured__overview");
    const featuredWatch = document.querySelector(".featured__watch");
    const featuredList = document.querySelector(".featured__list");
    featuredOverview.dataset.title = data.title;
    featuredOverview.dataset.movie_id = data.id;
    featuredTitle.textContent = data.title;
    featuredInfo.classList.add("featured__info");
    featuredDate.textContent = data.release_date.slice(0, 4);
    featuredGenre.textContent = genre;
    featuredOverview.textContent = data.overview;
    featuredWatch.textContent = "Start";
    featuredList.textContent = "Add to List";
};
// --------- SEARCH DOM RENDER ---------
const $0d253f80dc492c18$var$searchInput = document.querySelector(".nav__input");
const $0d253f80dc492c18$var$searchButton = document.querySelector(".nav__search-btn");
const $0d253f80dc492c18$var$mobileInput = document.querySelector(".mobile-menu__input");
const $0d253f80dc492c18$var$mobileSearchButton = document.querySelector(".mobile-menu__search-btn");
const $0d253f80dc492c18$export$c9a1649f3f80793f = function(handler) {
    const invalidChars = [
        "{",
        "}",
        "<",
        ">",
        "[",
        "]",
        ";",
        "|"
    ];
    $0d253f80dc492c18$var$searchInput.addEventListener("keypress", function(e) {
        if (e.key === "Enter") {
            if (!$0d253f80dc492c18$var$searchInput.value.split("").some((i)=>invalidChars.includes(i))) {
                handler($0d253f80dc492c18$var$searchInput.value);
                $0d253f80dc492c18$var$searchInput.value = "";
            } else {
                $0d253f80dc492c18$var$searchInput.setCustomValidity("Invalid characters { } [ ] < > ; |");
                $0d253f80dc492c18$var$searchInput.reportValidity();
            }
        }
    });
    $0d253f80dc492c18$var$mobileInput.addEventListener("keypress", function(e) {
        if (e.key === "Enter") {
            if (!$0d253f80dc492c18$var$mobileInput.value.split("").some((i)=>invalidChars.includes(i))) {
                handler($0d253f80dc492c18$var$mobileInput.value);
                $0d253f80dc492c18$var$mobileInput.value = "";
                $0d253f80dc492c18$var$main.classList.toggle("active");
                $0d253f80dc492c18$var$hamburgerMenu.classList.toggle("active");
                $0d253f80dc492c18$var$mobileMenu.classList.toggle("active");
            } else {
                $0d253f80dc492c18$var$mobileInput.setCustomValidity("Invalid characters { } [ ] < > ; |");
                $0d253f80dc492c18$var$mobileInput.reportValidity();
            }
        }
    });
    $0d253f80dc492c18$var$searchButton.addEventListener("click", function() {
        if (!$0d253f80dc492c18$var$searchInput.value.split("").some((i)=>invalidChars.includes(i))) {
            handler($0d253f80dc492c18$var$searchInput.value);
            $0d253f80dc492c18$var$searchInput.value = "";
        } else {
            $0d253f80dc492c18$var$searchInput.setCustomValidity("Invalid characters { } [ ] < > ; |");
            $0d253f80dc492c18$var$searchInput.reportValidity();
        }
    });
    $0d253f80dc492c18$var$mobileSearchButton.addEventListener("click", function() {
        if (!$0d253f80dc492c18$var$mobileInput.value.split("").some((i)=>invalidChars.includes(i))) {
            handler($0d253f80dc492c18$var$mobileInput.value);
            $0d253f80dc492c18$var$mobileInput.value = "";
            $0d253f80dc492c18$var$main.classList.toggle("active");
            $0d253f80dc492c18$var$hamburgerMenu.classList.toggle("active");
            $0d253f80dc492c18$var$mobileMenu.classList.toggle("active");
        } else {
            $0d253f80dc492c18$var$mobileInput.setCustomValidity("Invalid characters { } [ ] < > ; |");
            $0d253f80dc492c18$var$mobileInput.reportValidity();
        }
    });
};
const $0d253f80dc492c18$export$20800ba040e1775e = function(result, query) {
    $0d253f80dc492c18$export$427e1bf20300bdf0(result, query);
    const genreTitle = document.querySelector(".movie-grid__title");
    genreTitle.textContent = `Your search results for: ${query}`;
};
const $0d253f80dc492c18$export$102de28e9a533191 = function(handler) {
    document.addEventListener("click", function(e) {
        if (e.target.matches(".movie-grid__delete-button")) handler(e.target.dataset.movie_id);
    });
};
const $0d253f80dc492c18$export$990ba021348cea03 = function() {
    const main = document.querySelector(".main");
    const moviesArray = localStorage.getItem("watchList") ? JSON.parse(localStorage.getItem("watchList")) : [];
    if (moviesArray.length === 0) {
        const errorMessage = document.createElement("h1");
        errorMessage.classList.add("watchlist__error");
        errorMessage.textContent = "Your watchlist is empty";
        main.innerHTML = "";
        main.appendChild(errorMessage);
    } else {
        const main = document.querySelector(".main");
        const imgPath = "https://image.tmdb.org/t/p/original";
        const container = document.createElement("div");
        container.classList.add("container");
        container.classList.add("grid");
        const genreTitle = document.createElement("h2");
        genreTitle.classList.add("movie-grid__title");
        genreTitle.textContent = "Your Watchlist";
        container.appendChild(genreTitle);
        moviesArray.forEach((movie)=>{
            const movieGridItem = document.createElement("div");
            movieGridItem.classList.add("movie-grid__item");
            const movieGridIMG = document.createElement("img");
            movieGridIMG.dataset.title = movie.original_title;
            movieGridIMG.dataset.movie_id = movie.id;
            movieGridIMG.classList.add("movie-grid__img");
            movieGridIMG.src = `${imgPath}${movie.poster_path}`;
            const newWatchButton = document.createElement("button");
            newWatchButton.classList.add("movie-grid__watch-button");
            newWatchButton.textContent = "Watch";
            newWatchButton.addEventListener("click", function() {
                $0d253f80dc492c18$var$clickedTitle = this.previousSibling.dataset.title;
                $0d253f80dc492c18$var$clickedID = this.previousSibling.dataset.movie_id;
            });
            const newListButton = document.createElement("button");
            newListButton.classList.add("movie-grid__list-button");
            newListButton.textContent = "Add to List";
            newListButton.addEventListener("click", function() {
                $0d253f80dc492c18$var$clickedTitle = this.previousSibling.previousSibling.dataset.title;
                $0d253f80dc492c18$var$clickedID = this.previousSibling.previousSibling.dataset.movie_id;
            // modalConfirmation();
            });
            const newDeleteButton = document.createElement("button");
            newDeleteButton.classList.add("movie-grid__delete-button");
            newDeleteButton.dataset.movie_id = movie.id;
            newDeleteButton.textContent = "Delete";
            movieGridItem.appendChild(movieGridIMG);
            movieGridItem.appendChild(newWatchButton);
            movieGridItem.appendChild(newListButton);
            movieGridItem.appendChild(newDeleteButton);
            container.appendChild(movieGridItem);
        });
        main.innerHTML = "";
        main.appendChild(container);
    }
};
const $0d253f80dc492c18$var$watchListButton = document.getElementById("nav-watchlist");
$0d253f80dc492c18$var$watchListButton.addEventListener("click", $0d253f80dc492c18$export$990ba021348cea03);
const $0d253f80dc492c18$export$89576f0028979742 = function() {
    const main = document.querySelector(".main");
    const errorMessage = document.createElement("h1");
    errorMessage.classList.add("watchlist__error");
    errorMessage.textContent = "Something went wrong with your request";
    main.innerHTML = "";
    main.appendChild(errorMessage);
};


// --------- LOAD INITIAL FEATURED TRENDING FROM API BY RANDOM ---------
const $f50bd1f2915ed0f2$var$loadInitial = async function() {
    try {
        const data = await $0f1d4402dffacf5b$export$6405226d42414f72();
        $0d253f80dc492c18$export$5e5c8210e5686582(data);
    } catch (error) {
        console.log(error);
        $0d253f80dc492c18$export$89576f0028979742();
    }
};
const $f50bd1f2915ed0f2$var$loadGenre = async function(query) {
    try {
        const result = await $0f1d4402dffacf5b$export$dff0df0fb1888b81(query);
        $0d253f80dc492c18$export$427e1bf20300bdf0(result, query);
    } catch (error) {
        console.log(error);
        $0d253f80dc492c18$export$89576f0028979742();
    }
};
const $f50bd1f2915ed0f2$var$loadWatch = async function(query) {
    try {
        const result = await $0f1d4402dffacf5b$export$b0c4d3ac9887d994(query);
        if (document.querySelector(".featured")) $0d253f80dc492c18$export$be99db7b1960a5b8(result, query);
        else {
            const data = await $0f1d4402dffacf5b$export$6405226d42414f72();
            $0d253f80dc492c18$export$5e5c8210e5686582(data);
            $0d253f80dc492c18$export$be99db7b1960a5b8(result, query);
        }
    } catch (error) {
        console.log(error);
        $0d253f80dc492c18$export$89576f0028979742();
    }
};
const $f50bd1f2915ed0f2$var$loadSearch = async function(query) {
    try {
        const result = await $0f1d4402dffacf5b$export$b0c4d3ac9887d994(query);
        $0d253f80dc492c18$export$20800ba040e1775e(result, query);
    } catch (error) {
        console.log(error);
        $0d253f80dc492c18$export$89576f0028979742();
    }
};
const $f50bd1f2915ed0f2$var$pass2LocalStorage = async function(query, id) {
    try {
        await $0f1d4402dffacf5b$export$f3928fa528b0a11c(query, id);
        $0d253f80dc492c18$export$d0ef1bf9bfa6564("Movie has been added");
    } catch (error) {
        console.log(error.message);
        $0d253f80dc492c18$export$d0ef1bf9bfa6564(error.message);
    }
};
const $f50bd1f2915ed0f2$var$deleteFromLocalStorage = function(id) {
    $0f1d4402dffacf5b$export$63174eb60e426b63(id);
    $0d253f80dc492c18$export$990ba021348cea03();
};
const $f50bd1f2915ed0f2$var$init = function() {
    $f50bd1f2915ed0f2$var$loadInitial();
    $0d253f80dc492c18$export$fd3ff2941ee1f095($f50bd1f2915ed0f2$var$loadGenre);
    $0d253f80dc492c18$export$f3d839c0582bbe9c($f50bd1f2915ed0f2$var$loadInitial);
    $0d253f80dc492c18$export$361292eb141e7484($f50bd1f2915ed0f2$var$loadWatch);
    $0d253f80dc492c18$export$c9a1649f3f80793f($f50bd1f2915ed0f2$var$loadSearch);
    $0d253f80dc492c18$export$b0c42ac82fb8127($f50bd1f2915ed0f2$var$pass2LocalStorage);
    $0d253f80dc492c18$export$102de28e9a533191($f50bd1f2915ed0f2$var$deleteFromLocalStorage);
    $0d253f80dc492c18$export$a11e9b05256bf37c($f50bd1f2915ed0f2$var$loadInitial);
    $0d253f80dc492c18$export$96250e6ba255f1e1($f50bd1f2915ed0f2$var$loadGenre);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.86b58dbc.js.map
